import { render, staticRenderFns } from "./Productos.vue?vue&type=template&id=50e4c3c1&scoped=true&"
import script from "./Productos.vue?vue&type=script&lang=js&"
export * from "./Productos.vue?vue&type=script&lang=js&"
import style0 from "./Productos.scss?vue&type=style&index=0&id=50e4c3c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e4c3c1",
  null
  
)

export default component.exports